import { createFileRoute } from '@tanstack/react-router'
import { LegalPageShell } from '@/components/LegalPageShell'

export const Route = createFileRoute('/cookie-policy')({
  component: CookiePolicyPage,
})

function CookiePolicyPage() {
  return (
    <LegalPageShell title="Cookie Policy" updated="September 13, 2026">
      <section className="space-y-4">
        <p className="text-sm leading-relaxed text-white/60">
          This policy explains how PeerPass uses cookies and similar technologies (such as browser
          storage) across its website and portal.
        </p>
      </section>

      <section className="space-y-4">
        <h2 className="text-xl font-semibold text-white">1. What are cookies?</h2>
        <p className="text-sm leading-relaxed text-white/60">
          Cookies are small text files stored on your device by your browser. Similar technologies
          include local storage and session storage, which also let a website remember information
          during or between visits.
        </p>
      </section>

      <section className="space-y-4">
        <h2 className="text-xl font-semibold text-white">2. How we use them</h2>
        <ul className="list-disc space-y-2 pl-5 text-sm leading-relaxed text-white/60">
          <li>
            <strong className="text-white/80">Strictly necessary</strong> &mdash; to keep you signed
            in and to deliver the core portal functionality you request.
          </li>
          <li>
            <strong className="text-white/80">Preferences</strong> &mdash; to remember choices such
            as your display theme (e.g. dark mode).
          </li>
          <li>
            <strong className="text-white/80">Functional</strong> &mdash; to remember your detected
            country so we can show you the correct regional pricing.
          </li>
          <li>
            <strong className="text-white/80">Performance &amp; diagnostics</strong> &mdash; to
            detect errors and measure reliability through our error-monitoring service, so we can
            fix issues quickly.
          </li>
        </ul>
      </section>

      <section className="space-y-4">
        <h2 className="text-xl font-semibold text-white">3. Third-party cookies</h2>
        <p className="text-sm leading-relaxed text-white/60">
          Some third-party services we use &mdash; such as our payment processor on checkout and our
          error-monitoring service &mdash; may set cookies of their own. These cookies are subject
          to the respective provider&rsquo;s policies and are used only to provide their service to
          us (for example, to process a payment or report a crash).
        </p>
      </section>

      <section className="space-y-4">
        <h2 className="text-xl font-semibold text-white">4. Your choices</h2>
        <p className="text-sm leading-relaxed text-white/60">
          You can configure your browser to block or delete cookies, and to clear local and session
          storage. Some strictly necessary functionality (such as staying signed in or regional
          pricing) may not work as expected if you block these technologies, but the site will
          remain usable.
        </p>
      </section>

      <section className="space-y-4">
        <h2 className="text-xl font-semibold text-white">5. Changes &amp; contact</h2>
        <p className="text-sm leading-relaxed text-white/60">
          We may update this policy from time to time. The current version is always available on
          this page. Questions?{' '}
          <a href="/contact" className="text-[#00E5A0] hover:underline">
            Contact us
          </a>.
        </p>
      </section>
    </LegalPageShell>
  )
}